export interface BookImage {
  key: string;
  url: string;
}

export function getBookImageUrl(image: BookImage | string | undefined): string {
  if (!image) return '';
  return typeof image === 'string' ? image : image.url;
}

export interface IBookData {
  _id: string;
  title: string;
  slug: string;
  description: string;
  price: number;
  images: BookImage[];
  bookType: string;
  category: string;
  subCategory: SubCategory;
  bookEdition: number;
  bookCondition: string;
  bookStatus: string;
  views: number;
  numberOfBooks: number;
  educationTerm: string;
  educationType: string;
  location: string;
  city: string;
  reportStatus: boolean;
  postedBy: PostedBy;
  createdAt: Date;
  updatedAt: Date;
  createdBy: createdBy;
}

export interface PostedBy {
  _id: string;
  fullName: string;
  gender: string;
}

export interface SubCategory {
  _id: string;
  subCategory: string;
}

export interface createdBy {
  _id: string;
  role: string;
  fullName: string;
  email: string;
  phoneNumber?: string;
  gender: string;
  isActive: boolean;
  isBlocked: boolean;
}
